import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import axios from "axios"
import Button from '@mui/material/Button';
import Table from "react-bootstrap/Table"
import "datatables.net-dt/css/dataTables.dataTables.min.css"
import DataTable from "datatables.net-dt/js/dataTables.dataTables.min.js"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {NavLink} from 'react-router-dom'

const DeleteOffer = () => {
    const[data,setData]=useState([])
   useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/offer`)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching offers")
    })
    setTimeout(()=>{
      new DataTable('#serviceTable')
    },1000)
  
  })
  
  const deleteOfferData =(sid)=>{
    axios.delete(`https://backendsurgylife-1.onrender.com/offer/${sid}`)
    .then((res)=>{
      alert("offer Deleted Successfully")
    })
    .catch((err)=>{
      alert("Error Deleting offer")
    })
  }



  return (
   <main>
  

      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
 <Table striped bordered hover id='serviceTable'>
      <thead>
        <tr>
          <th>OName</th>
          <th>ODesc</th>
          <th>OExpires</th>
         <th>Action</th>

        </tr>
      </thead>

      <tbody>
         {
          data.map((offersdata)=>{
          return(
            <tr key={offersdata._id}>
              <td>{offersdata.oname}</td>
              <td>{offersdata.odesc}</td>
              <td>{offersdata.datetime}</td>

          
                <td className='d-flex  justify-content-center  '>
      <Button variant="contained" color='error' className='me-3' onClick={()=>{deleteOfferData(offersdata._id)}}>
        <DeleteIcon/>
      </Button>


      <Button 
                       variant="outlined"
                        color='success'
                       >
                        <NavLink to={`/editoffer/${offersdata._id}`}>
                                <EditIcon/>
                        </NavLink>
               
                          </Button>

                </td>
            </tr>
          )
          })
         }
          </tbody>
    </Table>
            </div>
          </div>
        </div>
      </section>

    </main>  )
}

export default DeleteOffer
